import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BaseCard from './BaseCard';
import { statBoxStyle, statValueStyle, statLabelStyle } from './cardStyles';
import { ZIMA_BLUE } from '../../../dashboardColors';

const FoundLeaksSummaryCard = ({ totalLeaks, fixedLeaks, t }) => (
  <BaseCard title={t('leaks_detected')} icon={<CheckCircleIcon />} className="compact-card">
    <Box display="flex" alignItems="center" justifyContent="center" height="100%" gap={1.5}>
      <Box sx={statBoxStyle}>
        <Typography className="stat-value" sx={{ ...statValueStyle, color: ZIMA_BLUE }}>
          {totalLeaks || 0}
        </Typography>
        <Typography sx={statLabelStyle}># {t('detected')}</Typography>
      </Box>
      <Box sx={statBoxStyle}>
        <Typography className="stat-value" sx={{ ...statValueStyle, color: ZIMA_BLUE }}>
          {fixedLeaks || 0}
        </Typography>
        <Typography sx={statLabelStyle}># {t('fixed')}</Typography>
      </Box>
    </Box>
  </BaseCard>
);

FoundLeaksSummaryCard.propTypes = {
  totalLeaks: PropTypes.number,
  fixedLeaks: PropTypes.number,
  t: PropTypes.func.isRequired
};

export default FoundLeaksSummaryCard;
